import { render, staticRenderFns } from "./DialogTextInput.vue?vue&type=template&id=521701a9"
import script from "./DialogTextInput.vue?vue&type=script&lang=js"
export * from "./DialogTextInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports